import React from 'react';

/**
 * The action at the bottom of Book's "Set drop on map" sheet. Normally the Confirm button. For
 * a drop outside the service area that can be booked as an Intertown trip, the disabled Confirm
 * button would be a dead end, so it is replaced by a way to book with Intertown instead. The
 * button takes the Confirm button's place, so the sheet is exactly as tall as before (the sheet
 * has a maximum height; its one-line hint above is swapped in Book, not added).
 */
export default function PinSheetAction({
  t, redirect, redirecting = false, onRedirect, confirmLabel, confirmDisabled, onConfirm,
}) {
  if (redirect?.ok) {
    return (
      <button
        type="button"
        className={`rapido-book-btn${redirecting ? ' loading' : ''}`}
        disabled={redirecting}
        onClick={onRedirect}
      >
        {t('book.intertownRedirectCta')}
      </button>
    );
  }
  return (
    <button type="button" className="rapido-book-btn" disabled={confirmDisabled} onClick={onConfirm}>
      {confirmLabel}
    </button>
  );
}
